<template>
    <div class="animated fadeIn master-detail-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="master-back-wrapper">
                <b-button type="button" name="cabangBackBtn" @click="$router.go(-1)">
                    <i class="fa fa-angle-left mr-2"></i>Back
                </b-button>
            </div>
            <div class="master-form-card">
            <h5 class="master-page-title">Detail Cabang</h5>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA UMUM</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kode Cabang</b-col>
                    <b-col>{{ cabang.kode }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Cabang</b-col>
                    <b-col>{{ cabang.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat Cabang</b-col>
                    <b-col>{{ cabang.alamat }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Provinsi Cabang</b-col>
                    <b-col>{{ cabang.provinsi ? cabang.provinsi.name : '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota Cabang</b-col>
                    <b-col>{{ cabang.kota.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kecamatan Cabang</b-col>
                    <b-col>{{ cabang.kecamatan ? cabang.kecamatan.name : '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelurahan Cabang</b-col>
                    <b-col>{{ cabang.kelurahan ? cabang.kelurahan.name : '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Telp Cabang</b-col>
                    <b-col v-if="cabang.noTelp != null">{{ cabang.noTelp }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cash in Hand</b-col>
                    <b-col>
                        <strong v-if="cabang.cashInHand == null">{{$helper.addThousandSeparator(cabang.cashInHand)}} </strong>
                        <strong v-else-if="cabang.cashInHand < 0">- Rp{{$helper.addThousandSeparator(cabang.cashInHand).replace("-", "")}}</strong>
                        <strong v-else>Rp. {{$helper.addThousandSeparator(cabang.cashInHand)}} </strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Skema Perhitungan</b-col>
                    <b-col>{{ cabang.skema.name }}</b-col>
                </b-row>
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Latitude</b-col>
                    <b-col v-if="cabang.latitude != null">{{ cabang.latitude }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Longitude</b-col>
                    <b-col v-if="cabang.longitude != null">{{ cabang.longitude }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat IP Cabang</b-col>
                    <b-col v-if="cabang.ipAddress != null">{{ cabang.ipAddress }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper">
                <h6 class="form-title">DATA STAFF</h6>
                <b-row class="mb-4">
                    <b-col cols="4" v-if="cabang.ku != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">KEPALA UNIT</div>
                            <h6 class="mb-1">{{ cabang.ku.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.ku.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.ku.email || "-" }}</div>
                        </div>
                    </b-col>
                    <b-col cols="4" v-if="cabang.kc != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">KEPALA CABANG</div>
                            <h6 class="mb-1">{{ cabang.kc.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.kc.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.kc.email || "-" }}</div>
                        </div>
                    </b-col>
                    <b-col cols="4" v-if="cabang.kcs != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">KEPALA CABANG SENIOR</div>
                            <h6 class="mb-1">{{ cabang.kcs.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.kcs.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.kcs.email || "-" }}</div>
						</div>
                    </b-col>
                </b-row>
                <b-table bordered hover show-empty
                    :busy="isBusy" 
                    :items="cabang.staffs" 
                    :fields="fields"
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data staff.
                    </template>
                    <template v-slot:cell(role)="row">
                        {{row.item.role.level}} - {{row.item.role.name}}
                    </template>
                </b-table>
                <div class="d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="cabangEditBtn" @click="editCabang">Edit</b-button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'detail-cabang',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
            },
            fields: [
                { key: "fullname", label: "Nama Staff", sortable:true},
                { key: "role", label: "Level - Role" },
                { key: "noHp", label: "No. Hp Staff", sortable:true},
                { key: "email", label: "Email Staff", sortable:true},
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            cabang: {
                ku: null,
                kc: null,
                kcs: null
            },
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: ''
        }
    }, 

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleCabang = this.$axios.get(`cabang/${this.id}`).then(response => {
                this.cabang = response.data

                //Update Total Item di Halaman
                this.rows = this.cabang.staffs.length
                if (this.perPage > this.rows) this.perPage = this.rows
                this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
                this.initStatus = 1;

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },
        

        //----------------- Fungsi Pagination -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editCabang(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        },
    },

    created(){
        this.init()
    }
}
</script>
